import type { orderFxData } from "./type";
import orderFxDataList from "../../../data/orderFxData.json";

export class orderFxService {
  async getOrderFxFile(clientId: number, filters: any) {
    const { data } = await this.getOrderFx(clientId, 0, 1000000, filters);
    return data;
  }

  async getOrderFx(
    clientId: number,
    page: number,
    size: number,
    filters: any
  ): Promise<{ data: orderFxData }> {
    if (!clientId) {
      throw new Error("clientId is required.");
    }

    let filteredOrderFx = orderFxDataList.data.filter(
      (orderFx) => orderFx.clientId === clientId
    );

    if (filters) {
      if (filters.date && filters.date.length === 2) {
        const [startRaw, endRaw] = filters.date.map((d: string) => new Date(d));

        // Normalizar las fechas al inicio del día
        const start = new Date(startRaw.setHours(0, 0, 0, 0));
        const end = new Date(endRaw.setHours(23, 59, 59, 999)); // incluir todo el día

        filteredOrderFx = filteredOrderFx.filter((item) => {
          const [dd, mm, yyyy] = item.date.split("/");
          const itemDate = new Date(`${yyyy}-${mm}-${dd}T00:00:00`);
          return itemDate >= start && itemDate <= end;
        });
      }
    }

    const total = filteredOrderFx.length;
    const start = page * size;
    const end = start + size;
    const paginatedData = filteredOrderFx.slice(start, end);
    return {
      data: {
        total,
        totalPages: Math.ceil(total / size),
        page,
        pageSize: size,
        orderFx: paginatedData,
      },
    };
  }
}
